<template>
  <div id="app">

    <mt-header title="个人信息">
      <router-link to="/" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <label></label>
    <div style="line-height:18px;margin:20px;">
      <div>
        <label id="tip">请填写真实的个人身份信息！</label>
      </div>
    </div>
   
    <label></label>
    
    <mt-field class="tiplabel" label="姓名" style="text-align: left;" placeholder="请输入姓名" v-model="username"></mt-field>

    <mt-cell class="tiplabel" title="性别" style="text-align: left;">
      <span id="test" @click="sexVisible = true" style="color: green;font-size:18px;text-align:center;display:block;">{{sextip}}{{sex}}</span>
    </mt-cell>

    <mt-field class="tiplabel"  label="手机号" style="text-align: left;" placeholder="请输入手机号" type="tel" v-model="phone"></mt-field>
    <mt-field class="tiplabel"  label="身份证号" style="text-align: left;" placeholder="请输入身份证号" v-model="idnumber"></mt-field>
    <div class="sexPicker">
       <mt-popup
           v-model="sexVisible"
            position="bottom" style="width:100%;height:43%;">
            <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
         </mt-popup>
    </div>

    <mt-button type="primary" @click="saveInfo" size="large">保存</mt-button>

    <br>
  </div>
  
</template>

<script>
import 'mint-ui/lib/style.css'
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      sextip:'请选择性别',
      wxopenid:'',
      username:'',
      sex:'',
      phone:'',
      idnumber:'',
      sexVisible: false,  //选择器的显示与影藏
      slots:[{flex:1,values: ['男', '女']}],
      toastInstanse: null
    }
  },
  mounted(){
    // 1、获取传过来的openid    
    this.wxopenid=this.$route.params.openid;
    if(this.wxopenid==null){
      // alert(this.$route.params.openid);
      // 跳转到错误处理页
      this.$router.push({path:'/err'});
    }

    // 2、检查个人信息情况
    this.getInfo();
  },
  methods:{
    onValuesChange(picker, values) {
      //console.log(values)
      this.sex = values[0];
      this.sexVisible = false;
      var cont=document.getElementById("test");
      if(cont.innerText=='请选择性别'){
        this.sextip=null;
      }
    },
    getInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxopenid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
        //console.log(response);     
        if(response.data.data.name!=null){
          // 渲染信息
          this.username=response.data.data.name;
          this.sex=response.data.data.sex;
          this.phone=response.data.data.tel;
          this.idnumber=response.data.data.idnumber;
        }

      }),function(err){
          console.log(err);
      }
    },
    checkIDCard(idcode){
      // 加权因子
      var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
      // 校验码
      var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

      var code = idcode + "";
      var last = idcode[17];//最后一位
      var seventeen = code.substring(0,17);
      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for(var i = 0; i < len; i++){
          num = num + arr[i] * weight_factor[i];
      }
      
      // 获取余数
      var resisue = num%11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
      第一位不可能是0
      第二位到第六位可以是0-9
      第七位到第十位是年份，所以七八位为19或者20
      十一位和十二位是月份，这两位是01-12之间的数值
      十三位和十四位是日期，是从01-31之间的数值
      十五，十六，十七都是数字0-9
      十八位可能是数字0-9，也可能是X
      */
      var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

      // 判断格式是否正确
      var format = idcard_patter.test(idcode);
      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      return last === last_no && format ? true : false;
    },
    // 验证数据的有效性
    CheckData(){
      if(this.username==null  || this.username=='')
      {
        alert('请填写真实姓名');
        return false;
      }
      if(this.sex==null || this.sex=='')
      {
        alert('请选择性别');
        return false;
      }
      if(this.phone==null || this.phone=='')
      {
        alert('请输入手机号码');
        return false;
      }
      // 验证身份证有效性
      if(this.idnumber==null || this.idnumber=='')
      {
        alert('身份证号不合法');
        return false;
      }
      if(!this.checkIDCard(this.idnumber))
      {
        alert('身份证号不合法');
        return false;
      }      
      
      return true;
    },
    // 保存个人信息
    saveInfo(){
      // 1、验证数据有效性
      if(!this.CheckData())
      {
        return;
      }
      // 2、保存数据
      var api='http://localhost:6334/api/submitbaseinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxopenid,
        'name':this.username,
        'sex':this.sex,
        'phone':this.phone,
        'idnumber':this.idnumber
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
          // alert(response);
          // 信息保存成功
          alert('保存成功');
          // 跳转到预约首页
          this.$router.push({path:'/appointment'});
      }),function(err){
          // 保存出错
          alert(err);
      }
    },
    show() {
      // 每当调用的时候，Toast 有一个返回值，这个返回值 重新赋值给 toastInstanse ,以至于后边手动关闭Toast
      this.toastInstanse = Toast({
        message: "个人信息保存成功", //弹窗内容
        position: "middle", //弹窗位置
        iconClass: "icon icon-success" //设置 图标类
      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: left; */
  color: #2c3e50;
  margin-top: 0px;
}

/* label {
        text-align:left;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
mt-popup,mt-picker{
  width: 100%;
}


.picker-center-highlight{
  background-color: #F5F5F9;
  z-index:-100;
}

sexPicker{
  width: 100%;
} */
#tip{
  color: #ee0d0d;
  text-align: center;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/baseinfo.vue